<template>
  <div :class="deriveClass">
    <label class="field-title" :class="{'on': internalValue || focussed || placeholder}">
      {{displayLabel}}
    </label>

    <select class="form-control" @input="validate($event.target.value)" :readonly="readonly" :required="required" :value="internalValue">
      <!-- <option value="" disabled selected>{{placeholderContent}}</option> -->
      <option v-for="option in allowedValues" :value="option.value || option">
        {{option.display_name || option}}
      </option>
    </select>

    <p class="error-msg"></p>
  </div>
</template>

<script>
export default {
  name: 'select-field',
  data () {
    return {
      id: this.config.id,
      name: this.config.name,
      optional: !this.config.required,
      label: this.config.label,
      readonly: this.config.read_only,
      required: this.config.required,
      placeholder: "",
      internalValue: this.value || this.config.def_value,
      allowedValues: this.config.allowed_values,
      focussed: false
    }
  },
  props: ['config', 'value', 'customclass'],
  computed: {
    displayLabel() {
      return !this.optional ? this.label : this.label + " (Optional)";
    },

    placeholderContent() {
      return this.internalValue || this.focussed ? null : this.placeholder;
    },

    deriveClass() {
      var o = {
        'optional': this.optional,
        'focus-input': this.focussed
      }
      if(this.customclass) {
        o[this.customclass] = true;
      }
      return o;
    }
  },
  methods: {
    validate(value) {
      //TODO handle default value
      this.internalValue = value;
      this.$emit('input', value);
    }
  }
}
</script>


// WEBPACK FOOTER //
// SelectField.vue?d3937996